import { FC } from "react";

import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

const StyledDivider = styled(Box)(({ theme }) => {
  return {
    width: "100%",
    height: "0",
    borderBottomWidth: 1,
    borderBottomStyle: "dashed",
    borderBottomColor: theme.palette.secondary.main,
  };
});

const Divider: FC = () => {
  return <StyledDivider />;
};

export default Divider;
